const DemoFBS_Dash_Setting = (props) => {
  return (
    <section>Settings</section>
  );
}
export default DemoFBS_Dash_Setting;